import React, { useEffect, useState } from 'react';
import { AudioLines, X } from 'lucide-react';

interface AudioEnableOverlayProps {
  show: boolean;
  onEnable: () => void;
}

const AudioEnableOverlay: React.FC<AudioEnableOverlayProps> = ({ show, onEnable }) => {
  const [showImpressum, setShowImpressum] = useState(false);

  const handleOverlayClick = (e: React.MouseEvent) => {
    e.stopPropagation()
    if (e.target === e.currentTarget) {
      onEnable();
    }
  }

  const openLink = (e: React.MouseEvent, url: string) => {
    e.stopPropagation()
    window.open(url, '_blank');
  }

  const openImpressum = (e: React.MouseEvent) => {
    e.stopPropagation();
    setShowImpressum(true);
  }

  const closeImpressum = (e: React.MouseEvent) => {
    e.stopPropagation();
    setShowImpressum(false);
  }

  return (
    <div
      className={`fixed inset-0 bg-black/10 backdrop-blur-lg flex z-50 cursor-pointer transition-all ${show ? 'opacity-100 pointer-events-auto duration-300' : 'opacity-0 pointer-events-none duration-300 delay-1000'
        }`}>
      <div
        className={`flex w-full h-full transition-all ease-super-ease-out bg-no-repeat bg-cover bg-center
          ${show ? 'scale-100 delay-300 duration-500' : 'scale-[130%] blur-2xl delay-300 duration-500'}`}
        style={{
          backgroundImage: 'url(/paul.jpg)',
        }}>
        <div
          className={`relative w-full z-10 text-center md:text-left text-black p-4 flex flex-col gap-1 transition-all ease-super-ease-out
            ${show ? 'opacity-100 delay-700 duration-1000' : 'opacity-0 blur-sm duration-200 translate-y-1'}`}>
          <div className='relative text-sumo-orange drop-shadow-smooth align-text-top left-0.5 p-0 m-0 text-[2.2em] md:text-[4em] leading-[97%] md:leading-[1em] max-w-[1200px]'>
            Sound is more than music. It's a powerful tool to shape perception, emotion and connection. I design audio experiences for brands, spaces and live environments — developing concepts and translating them into tangible sound across real-world touch points. Making identity audible. Creating impact through sound.
          </div>
          <h2 className='relative text-[#e9e9e9] mt-4 text-lg leading-[80%] md:leading-[80%] p-0 m-0 md:text-3xl left-0.5 font-bold '>Paul Goeritz</h2>
          <h2 className='relative text-[#e9e9e9] text-lg leading-[80%] md:leading-[80%] p-0 m-0 md:text-3xl left-0.5 font-bold'>DJ, Composer, Sound Designer</h2>
          <h2 className='relative text-[#e9e9e9] text-lg leading-[80%] md:leading-[80%] p-0 m-0 md:text-3xl left-0.5 font-bold'>
            <a onClick={e => openLink(e, 'mailto:sumo@sumolicious.de')} className='underline left-1 hover:text-black' >sumo@sumolicious.de</a>
          </h2>
          <h2 className='relative text-[#e9e9e9] text-lg leading-[80%] md:leading-[80%] p-0 m-0 md:text-3xl left-0.5 font-bold'>
            <a onClick={e => openLink(e, 'https://www.instagram.com/sumo.music')} className='underline hover:text-black' >instagram</a>
          </h2>
          <h2 className='relative text-[#e9e9e9] opacity-15 text-lg leading-[80%] md:leading-[80%] p-0 m-0 md:text-3xl left-0.5 font-bold'>
            <a onClick={openImpressum} className='underline hover:text-black cursor-pointer' >impressum</a>
          </h2>
        </div>
        <div
          className="fixed text-sumo-orange z-0 text-center w-full bottom-12 flex flex-col gap-2 items-center justify-center text-xs font-bold mt-4"
          onClick={handleOverlayClick}>
          <div className='flex items-center gap-1 animate-pulse'>
            {/* <AudioLines className='size-4'/>  */}
            Tap anywhere to enable audio
          </div>
        </div>
      </div>

      {/* Impressum Overlay */}
      {showImpressum && (
        <div
          className="fixed inset-0 z-60 flex items-center justify-center bg-black/40 backdrop-blur-3xl"
          onClick={closeImpressum}>
          <div
            className="bg-white text-black text-left p-12 max-w-lg w-full mx-4 rounded-3xl relative max-h-[80vh]"
            onClick={e => e.stopPropagation()}>
            <button
              className="absolute -top-8 right-4 text-white hover:text-gray-500"
              onClick={closeImpressum}>
              <X className="size-5" />
            </button>
            <h1 className="text-xl font-bold mb-4">Impressum</h1>
            <p className="mb-4">
              <strong>Angaben gemäß § 5 TMG</strong><br />
              Paul Göritz<br />
              Ludwigstraße 112<br />
              70197 Stuttgart<br />
              Deutschland
            </p>
            <p className="mb-4">
              <strong>Kontakt</strong><br />
              Telefon: +49 176 32270744<br />
              E-Mail: sumo@sumolicious.de
            </p>
            <p className="mb-4">
              <strong>Umsatzsteuer-ID</strong><br />
              Umsatzsteuer-Identifikationsnummer gemäß § 27a UStG: DE430139617
            </p>
            <p>
              <strong>Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV</strong><br />
              Paul Göritz<br />
              Ludwigstraße 112<br />
              70197 Stuttgart
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default AudioEnableOverlay;
